// The permitted currency codes are defined in ISO-4217 (e.g. 'NOK' or 'EUR' etc).
type CurrencyCode = 'NOK' | 'EUR' | 'DKK';

const numberFormatByCode: Record<CurrencyCode, Intl.NumberFormat> = {
    EUR: new Intl.NumberFormat('et', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }),
    NOK: new Intl.NumberFormat('nb', {
        style: 'currency',
        currency: 'NOK',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }),
    DKK: new Intl.NumberFormat('dk', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }),
};

const defaultNumberFormat = numberFormatByCode.NOK;

let numberFormat = defaultNumberFormat;

export function Currency() {
    return {
        setNumberFormat(code) {
            numberFormat = numberFormatByCode[code] || defaultNumberFormat;
        },
        format(value: number) {
            return numberFormat.format(value / 100);
        },
        Value({ value }: { value: number }) {
            return numberFormat.format(value / 100);
        },
    };
}
